export const ktpMy = {
    "老师":"Teacher",
    "学生":"Student",
    "身份认证":"Identity authentication",
    "进入机构后台":"Enter admin",
    "切换语言":"Switch language",
    "切换中文":"切换中文",
    "切换英文":"Switch English",
    "消息通知":"Message notification",
    "文库":"Library",
    "账号管理":"Account management",
    "VIP管理":"VIP management",
    "交易记录":"Transactions",
    "消息设置":"Message settings",
    "机构用户认证":"Institutional user authentication",
    "账号":"Account",
    "微信":"Wechat",
    "邮箱":"Email",
    "手机号":"Mobile",
    "密码":"Password",
    "退出登录":"Logout",
    "绑定邮箱":"Bind email address",
    "请输入图形验证码":"Please enter the graphic verification code",
    "年":" ",
    "月":" ",
    "超级VIP":"SVIP",
    "机构VIP":"Institutional VIP",
    "机构超级VIP":"Institutional SVIP",
    "到期":"",
    "到期头":"Expired on",
    "所授课程":"Courses taught",
    "请输入教授课程名称":"Please enter the name of the teaching course",
    "新增课程":"Add courses",
    "上传图片":"Upload pictures",
    "修改失败":"Modification failed",
    "未选择":"Not selected",
    "确定更改入学时间吗":"Are you sure to change the enrollment time",
    "入学时间修改成功":"Successful modification of enrollment time",
    "手动添加":"Add manually",
    "请输入专业名称":"Please enter the professional name",
    "高等教育":"HE",
    "高职教育":"HPE",
    "中职教育":"SVE",
    "请输入正确的专业":"Please enter the correct major",
    "专业不能为空":"Major cannot be empty",
    "新增专业":"Add major",
    "所授专业":"Major taught",
    "所学专业":"Major",
    "专业":"Major",
    "当前手机":"Current mobile phone:",
    "未绑定":"Unbound",
    "新手机号":"New mobile number",
    "请输入新手机号":"Please enter a new phone number",
    "请输入正确的手机号":"Please enter the correct mobile number",
    "验证并绑定":"Validate and bind",
    "请输入上方算式结果":"Please enter the result of the above formula",
    "请输入正确的验证码":"Please enter the correct verification code",
    "绑定成功":"Binding succeeded",
    "更换手机号":"Change phone number",
    "绑定手机号":"Bind mobile number",
    "解除绑定":"Unbind",
    "验证并解绑":"Verify and Unbind",
    "解除绑定成功":"Unbinding succeeded",
    "解除绑定失败":"Unbinding failed",
    "已绑定":"Bound",
    "退出成功":"Exit succeeded",
    "确认登出此账号":"Confirm to log out of this account?",
    "退出登录将解绑当前的微信号":"Log out and unbind the WeChat",
    "个":"",
    "头像":"Head portrait",
    "教工号":"Staff number",
    "身份":"Identity",
    "院系":"Departments",
    "个人资料":"Personal data",
    "图片正在插入中":"The picture is being inserted...",
    "请选择图片格式的文件":"Please select a picture",
    "图片最大不能超过5MB":"The maximum image size cannot exceed 5MB",
    "猜你喜欢":"Guess you like it",
    "人阅读":"read",
    "已认证的机构身份":"Authenticated agency identity",
    "点击卡片即可编辑已认证身份":"Click the card to edit the authenticated identity",
    "查看机构编排的课程":"View courses arranged by the organization",
    "请填写以下信息完成身份认证":"Please fill in the following information to complete the identity authentication",
    "您所在的学校已开通机构后台功能需要完成身份认证才能同步学校为您所排的课程":"Your school has opened the institutional background function. You need to complete the identity authentication to synchronize the courses arranged for you by the school",
    "学校机构":"School institutions",
    "请输入所在学校机构":"Enter your school",
    "请输入学校名称":"Please enter the name of the school",
    "取消绑定":"Unbind",
    "请输入姓名":"Please enter your name",
    "请输入学号":"Please enter the number",
    "请输入教工号":"Please enter the number",
    "以后再说":"later",
    "取消本次认证":"Cancel authentication",
    "确认认证":"Confirm authentication",
    "学校已为您进行排课新增排课课程如下您可以选择已经创建的课程绑定排课课程":"The school has arranged courses for you, and the newly added courses are as follows. You can select the courses that have been created and bind them to the scheduled courses.",
    "未被绑定的排课课程将为您自动创建新课程":"The unbound scheduled course will automatically create a new course for you.",
    "学校已为您进行排课新增排课课程如下您将自动加入以下课程":"The unbound scheduled course will automatically create a new course for you.",
    "认证其他机构":"+ Other authentication",
    "选择学校机构":"Select school institution",
    "确认自动创建课程":"Confirm automatic course creation?",
    "有":"There are",
    "门排课课程未进行绑定":"scheduled courses not bound",
    "系统将自动创建对应课程":"The system will automatically create the corresponding course",
    "暂不创建":"Do not create",
    "确认创建":"Confirm creation",
    "绑定失败":"Binding failed",
    "认证成功":"Authentication succeeded",
    "绑定课程":"Binding courses",
    "暂无课程":"No course",
    "已取消账号绑定":"Account binding cancelled",
    "可在个人中心处继续完成绑定流程":"You can continue to complete the binding process at the Personal Center.",
    "发布人":"Publisher:",
    "教学活动":"Teaching",
    "教务通知":"Academic",
    "系统通知":"System",
    "申诉":"Appeal",
    "互动试卷":"Interactive exam",
    "忽略全部":"Ignore All",
    "消息标题":"Message title",
    "课堂成员变动":"Class member changes",
    "默认周六21:30接收成员变动消息推送":"By default, at 21:30 on Saturday, the member change message will be pushed",
    "作业到期":"Homework due",
    "作业到截止日期接收消息通知":"Receive message notification when the job reaches the deadline",
    "课堂私信":"Classroom private letter",
    "有老师同学私信后接收消息推送":"Receive and push messages when there are private messages from teachers/classmates",
    "话题提醒":"Topic Reminder",
    "有老师同学发起话题后接收消息推送":"Receive the message after a teacher/classmate initiates a topic",
    "订单编号":"Order No.:",
    "待支付":"To be paid",
    "已退款":"Refunded",
    "已关闭":"Closed",
    "实付款":"Actual payment",
    "当前状态":"State",
    "未支付":"Unpaid",
    "已支付":"Paid",
    "开票状态":"Invoicing status",
    "交易类型":"Transaction Type",
    "订单编号2":"Order No",
    "请输入院系":"Please enter the department",
    "请输入正确的":"Please enter the correct",
    "不能为空":"Cannot be empty",
    "当前邮箱":"Current mailbox: ",
    "更换邮箱":"Replace mailbox",
    "确认解绑当前已绑定的邮箱吗":"Are you sure to unbind the currently bound mailbox?",
    "请输入新邮箱":"Please enter a new email address",
    "新邮箱":"New mailbox",
    "请输入正确的邮箱":"Please enter the correct email address",
    "新密码":"New password",
    "请输入新密码":"Please enter a new password",
    "请再输入新密码":"Please enter a new password again",
    "密码修改成功请重新登录":"Password modified successfully, please login again",
    "密码设置":"Password settings",
    "选择学校名称":"Select School Name",
    "请输入搜索关键词":"Please enter search keywords",
    "当前微信":"Current WeChat:",
    "绑定微信":"Bind WeChat",
    "长按二维码进行识别绑定":"Long press the QR code to identify and bind",
    "请输入加课码":"Please enter the class code",
    "进入课堂":"Enter the class",
    "直达课程列表":"Direct course list",

}
